<div class="yard-map-configuration">

  <div class="selection no-field-space">

    <div [formGroup]="mapSelectionForm">
      <mat-form-field class="map-selection" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.choose-map"></sc-dictionary-label>
        </mat-label>
        <mat-select
          name="selectedMap" formControlName="selectedMap">
          @for (configuration of configurations; track configuration) {
            <mat-option [value]="configuration.id">
              {{configuration.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="spaced"></div>

    <sc-button dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.action.add-configuration" type="button" (click)="addMapConfiguration()"></sc-button>

    <div class="spaced grow"></div>

    <div [formGroup]="mapNameForm">
      <mat-form-field class="map-name" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
        </mat-label>
        <input matInput name="name" formControlName="name"
          [required]="true" maxlength="255">
        </mat-form-field>
      </div>

      <div class="spaced"></div>

      <sc-save-button dictionaryKey="tmc-yard.common.action.save" primary  type="button" (click)="saveMapConfiguration()"
      [disabled]="configuration == null || !configuration.dirty || configuration.invalid"></sc-save-button>

      <div class="spaced"></div>

      <sc-delete-button dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.action.delete-configuration" type="button" (click)="deleteMapConfiguration()"></sc-delete-button>

    </div>


    <div class="editor">
      <div class="col-wrapper">
        <div class="stations">
          <div class="stations-layout">
            <div class="stations-header">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.stations.header"></sc-dictionary-label>
            </div>
            <div class="stations-content-area">
              <div class="stations-entries-scrollable">
                @for (station of stations; track station) {
                  <div class="station-container">
                    <div class="station" draggable="true" (dragstart)="onDragStationStart($event, station)"
                      (dragend)="onDragStationEnd($event)">
                      {{station.name}}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>


        @if (configuration != null) {
          <div class="center">
            <div class="center-content">
              <div #mapContainer id="map-container" class="map-container"
                [ngStyle]="{'width': configuration.width+'px', 'height': configuration.height+'px'}"
                (dragover)="onDragOverMap($event)" (drop)="onDropToMap($event)">
                @if (configuration.mapResourceUUID != null && configuration.mapURL) {
                  <img [src]="configuration.mapURL" alt="map"
                    [ngStyle]="{'width': configuration.width+'px', 'height': configuration.height+'px'}"
                    />
                }
                @for (station of configuration.stationAssignments; track station) {
                  @if (!station.deleted) {
                    <div class="station" [ngClass]="{'waitingarea':station.isWaitingArea, 'selected': station.selected, 'extended': extendedStationTile}" draggable="true"
                      (dragover)="onDragOverStation($event)" (click)="selectStationAssignment(station)"
                      (drop)="onDropToStation($event, station)" (dragstart)="onDragStationAssignmentStart($event, station)"
                      [ngStyle]="{'left': station.x+'px', 'top': station.y+'px', 'border-color':station.color}">
                      <div class="station-inner">
                        @if (station.name && !station.identifier) {
                          <div class="station-identifier" [ngStyle]="{'color': station.fontColor }"
                            >
                            {{ station.name | uppercase }}
                          </div>
                        }
                        @if (station.identifier) {
                          <div class="station-identifier" [ngStyle]="{'color': station.fontColor }">
                            {{ station.identifier | uppercase }}
                          </div>
                        }
                        @if (station.isWaitingArea) {
                          <div>
                            <div class="waitingarea-occupancy-numbers">
                              X / Y
                            </div>
                            <div class="waitingarea-occupancy">
                              <div class="waitingarea-occupancy-percentage"></div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }


        <div class="details">
          <div class="map-details">

            <div class="details-header">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.map-details"></sc-dictionary-label>
            </div>


            <app-map-details [configuration]="configuration"></app-map-details>

            <div class="details-header">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.station-details"></sc-dictionary-label>
            </div>

            @if (configuration) {
              <app-station-assignment-details (stationAssignmentRemoved)="onStationAssignmentRemoved($event)"
                [assignment]="configuration.selectedStationAssignment" [configuration]="configuration"
                >
              </app-station-assignment-details>
            }

            <div class="legend">
              <div class="details-header">
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.legend"></sc-dictionary-label>
              </div>

              @if (configuration != null) {
                <div cdkDropList (cdkDropListDropped)="dropLegendListEntry($event)" class="legend-entries"
                  >
                  @for (entry of configuration.legendEntries; track entry) {
                    <div cdkDrag>
                      @if (entry.id !== configuration.editableLegendEntry?.id && !entry.deleted) {
                        <div class="legend-entry">
                          <div class="legend-entry-layout" (click)="editLegendEntry(entry)">
                            <i draggable="true" (dragstart)="onDragLegendEntryStart($event, entry)"
                            class="legend-entry-drag-arrow fa-light fa-arrow-left"></i>
                            <div class="colored-icon" [ngStyle]="{'background-color':entry.color}">
                              <i [ngStyle]="{'color': entry.fontColor }" class="fa-light fa-paragraph"></i>
                            </div>
                            <div class="name">{{entry.name}}
                            </div>
                            <div class="legend-entry-drag-handle">
                              <i cdkDragHandle class=" fa-light fa-bars"></i>
                            </div>
                          </div>
                        </div>
                      }
                      @if (entry.id === configuration.editableLegendEntry?.id  && !entry.deleted) {
                        <div class="legend-entry-editor" [formGroup]="legendEntryForm"
                          >
                          <div class="legend-entry-editor-layout">
                            <i draggable="true" (dragstart)="onDragLegendEntryStart($event, entry)"
                            class="legend-entry-drag-arrow fa-light fa-arrow-left"></i>
                            <div class="editor-fields">
                              <div class="editor-fields-layout">
                                <div class="row">
                                  <div class="row-layout">
                                    <mat-form-field class="input" class="grow" appearance="fill">
                                      <mat-label>
                                        <sc-dictionary-label dictionaryKey="tmc-yard.common.name"></sc-dictionary-label>
                                      </mat-label>
                                      <input autocomplete="off" matInput name="name" formControlName="name" [required]="true" maxlength="255">
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="row-layout">
                                    <mat-form-field class="grow" appearance="fill">
                                      <mat-label>
                                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.color"></sc-dictionary-label>
                                      </mat-label>
                                      <app-color-picker formControlName="color" (colorSelected)="colorPickerChanged()"
                                        name="color" [required]="false">
                                      </app-color-picker>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="row-layout">
                                    <mat-form-field class="grow" appearance="fill">
                                      <mat-label>
                                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.yard-map-configuration.font-color"></sc-dictionary-label>
                                      </mat-label>
                                      <app-color-picker formControlName="fontColor" (colorSelected)="colorPickerChanged()"
                                        name="fontColor" [required]="false">
                                      </app-color-picker>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <i (click)="removeLegendentry(entry)" class="fa-light fa-trash"></i>
                            <div class="legend-entry-drag-handle">
                              <i cdkDragHandle class=" fa-light fa-bars"></i>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <div class="legend-add-button" (click)="addLegendEntry()">
                <sc-icon iconClass="fa-plus"></sc-icon>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
